import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-obemasters',
  templateUrl: './obemasters.component.html',
  styleUrls: ['./obemasters.component.scss'],
  providers:[MasterService]
})
export class ObemastersComponent implements OnInit {

  
    memberdetails:any[]=[];
    classdetails:any[]=[];
    arrashead:any=[];
    arrastype:any=[];
    closeResult: string;
    classes: any=[];
    section: any=[];
    arrcourse:any=[];
    arrsubcomb:any=[];
    student:boolean=true;
    staff:boolean=false;
    memberdash:any={};
    objass:any={};
    objastype:any={};
    objfilt:any={};
    objgenfilt:any={gtype:'Reference Books'};
    objgen:any={};
    arreval:any=[];
    arrevpatern:any=[];
    arrcat:any=[];
    arract:any=[{name:'Yes'},{name:'No'}];
    arrledom1:any=[{name:'Cognitive'},{name:'Affective'},{name:'Psychomotor'}];
         
     arrledom:any=[{id:'0',name:'-'},{id:'1',name:'1'},{id:'2',name:'2'},{id:'3',name:'3'}];
    objmethod:any={};
    objpo:any={};
    objlevel:any={};
    objco:any={};
    modalOptions:NgbModalOptions;
    private modalRef: NgbModalRef;
  objfilt1: any={};
  arrgenmas: any;
  objfiltmat: any={};
  arrmatsubs: any=[];
   oprtype: string;
  enbtn: boolean;
  arrcomat:any=[];
  // objfilt: any;
  
    constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }
  
    open(content) {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return `with: ${reason}`;
      }
    }
  
  
  
    ngOnInit(): void {
       
      this.getobemlevels();
     
    }
  
  
    masclass() {
      this.mservice.masclass()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.classes = resultArray;
              this.objfilt.clid=resultArray[0].clid;
              this.objgenfilt.clid=resultArray[0].clid;
               this.objfiltmat.clid=resultArray[0].clid;
              // this.getobemco(this.objfilt);
              this.SelectClsSubDetails();
              this.SelectClsSubDetails1();
               this.SelectClsSubDetails3();
          },
          error => console.log("Error :: " + error)
          )
    }
  
    private getcourses() {
  
      this.mservice.getcourse()
    .subscribe((result:any) => {
    
    this.arrcourse=result;
    this.objfilt.crid=result[0].crid;
    this.objfilt1.crid=result[0].crid;
    this.objgenfilt.crid=result[0].crid;
    this.objfiltmat.crid=result[0].crid;
    this.masclass();
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }

     private getcourses1() {
      debugger
  
      this.mservice.getcourse()
    .subscribe((result:any) => {
    
    this.arrcourse=result;
  
    this.objfilt1.crid=result[0].crid;
    this.getobempo(result[0].crid);
    
    }, error => {
    
    //alert('error in r');
    // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
    }
    );
      
      
    }

       
 
      getobemcomatrix(obj) {
       this.mservice.getobemtcopo(obj,'selcomatrx')
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               
               if ( resultArray)
               {
               if (resultArray.length>0)
               {
                this.enbtn=true;
                this.oprtype="updcopo";
               this.arrcomat = resultArray;
               }
               else 
               {
                 this.arrcomat = [];
                this.enbtn=false;
               }
              }

               else 
               {
this.getobemconotexist(obj)

               }
           },
           error => console.log("Error :: " + error)
           )
     }
  
     getobemconotexist(obj) {
       this.mservice.getobemtcopo(obj,'selcos')
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               if (resultArray)
               {
                this.enbtn=true;
                this.oprtype="inscopo";
               this.arrcomat = resultArray;
               }
               else
               {
                this.enbtn=false;
                this.arrcomat = [];
               }
              
           },
           error => console.log("Error :: " + error)
           )
     }
 
    Getsubcomb()
    {
      debugger
      this.mservice.sel_sp_exmsubcomb()
      .subscribe(
        
       resultArray =>{
        console.log('result',resultArray) ;
        this.objfilt.sucbid=resultArray[0].sucbid;
        //this.clsdate=resultArray;
        this.arrsubcomb = resultArray;
        //this.getevpattern();
        },
       error => console.log("Error :: " + error)
    )
    }
     
    saveobemcopo()
   {
  //  console.log('saveobj',this.objco);
  var pst={stuarr:this.arrcomat,crid:this.objfiltmat.crid,clid:this.objfiltmat.clid,suid:this.objfiltmat.suid,oprtype:this.oprtype};
     this.mservice.saveobemcopo(pst)
         .subscribe(
         result => {
             console.log('SavegenmasDetails', result);
             //this.suppliers = resultArray;
             alert(result.message);
             if(result.status=='Success')
             {
              //  let localmodref=this.modalRef;
              //  localmodref.close();
             //  this.masasstype();
             this.getobemcomatrix(this.objfiltmat);
             }
            else
            {
   
            }
         },
         error =>{ alert('Error While saving...');}
         )
   }
 
 
 
  
    evalfilters()
    {
      this.masclass();
      this.getcourses();
      this.Getsubcomb();
    }
    massection() {
      this.mservice.massection()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.section = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }

        getobempo(crid) {
      this.mservice.getobempo(crid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrashead = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }

       getobemtmethod() {
      this.mservice.getobemtmethod()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrcat = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }

     getobemco(obj) {
      this.mservice.getobemco(obj)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrevpatern = resultArray;
             
          },
          error => console.log("Error :: " + error)
          )
    }

    getobemlevels() {
  
      // console.log('objfilt',this.objfilt);
      //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
      this.mservice.getobemlevels()
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              this.arrastype=resultArray;
              // if(oprtype=="selpo")
              // {
              //  this.arrashead=resultArray;
              // }
              // else if (oprtype=="selblchart")
              // {
              //   this.arrastype=resultArray;
              // }
              // else if (oprtype=="selco")
              // {
              // this.arrevpatern = resultArray;
              // }
             
          },
          error => console.log("Error :: " + error)
          )
    }
  
    SelectClsSubDetails() {
      debugger
      //var clid = this.clid;
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var clssubdata = { clid:this.objfilt.clid,clcd:clcd,aycd:aycd,crid:this.objfilt.crid };
      console.log('model', clssubdata);
      this.mservice.masclasssubject(clssubdata)
          .subscribe(resultArray => {
              console.log('classsubs', resultArray);
              this.arrsubcomb = resultArray;
              this.objfilt.suid=resultArray[0].suid;
              this.objgenfilt.suid=resultArray[0].suid;
              this.getobemco(this.objfilt);
              //alert (resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
      //this.closeAddExpenseModal.nativeElement.click();
  }

  SelectClsSubDetails1() {
      debugger
      //var clid = this.clid;
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var clssubdata = { clid:this.objgenfilt.clid,clcd:clcd,aycd:aycd,crid:this.objgenfilt.crid };
      console.log('model', clssubdata);
      this.mservice.masclasssubject(clssubdata)
          .subscribe(resultArray => {
              console.log('classsubs', resultArray);
              this.arrsubcomb = resultArray;
              // this.objfilt.suid=resultArray[0].suid;
              this.objgenfilt.suid=resultArray[0].suid;
              // this.getobemco(this.objfilt);
              //alert (resultArray.message);
  
          }, error =>
              alert('error in connection')
          );
      //this.closeAddExpenseModal.nativeElement.click();
  }

  SelectClsSubDetails3() {
      debugger
      //var clid = this.clid;
      let clcd=localStorage.getItem('clcd');
      let aycd=localStorage.getItem('aycd');
      var clssubdata = { clid:this.objfiltmat.clid,clcd:clcd,aycd:aycd,crid:this.objfiltmat.crid };
      console.log('model', clssubdata);
      this.mservice.masclasssubject(clssubdata)
          .subscribe(resultArray => {
              console.log('classsubs', resultArray);
              this.arrmatsubs = resultArray;
              // this.objfilt.suid=resultArray[0].suid;
              this.objfiltmat.suid=resultArray[0].suid;
               this.getobemcomatrix(this.objfiltmat);
           
  
          }, error =>
              alert('error in connection')
          );
      //this.closeAddExpenseModal.nativeElement.click();
  }
    
   
    getevpattern(oprtype,suid) {
  
      console.log('objfilt',this.objfilt);
      //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
      this.mservice.getevlcopomaster(oprtype,suid)
          .subscribe(
          resultArray => {
              console.log('getdashcounts', resultArray);
              if(oprtype=="selpo")
              {
               this.arrashead=resultArray;
              }
              else if (oprtype=="selblchart")
              {
                this.arrastype=resultArray;
              }
              else if (oprtype=="selco")
              {
              this.arrevpatern = resultArray;
              }
             // this.fmodel.asstypeId=resultArray[0].astpid;
          },
          error => console.log("Error :: " + error)
          )
    }
    includeorexclude(objdata,oprtype)
    {
      if(confirm(" Are you sure you wan't to "+oprtype))
      {
        objdata.oprtype=oprtype;
        objdata.clid=this.objfilt.clid;
        objdata.crid=this.objfilt.crid;
        objdata.sucbid=this.objfilt.sucbid;
        objdata.asid=this.objfilt.asid;
        objdata.astpid=this.objfilt.astpid;
  
        //this.saveevpattern(objdata);
      }
    }
  
    updatedet(objdata,oprtype)
    {
      
        objdata.oprtype=oprtype;
        objdata.clid=this.objfilt.clid;
        objdata.crid=this.objfilt.crid;
        objdata.sucbid=this.objfilt.sucbid;
        objdata.asid=this.objfilt.asid;
        objdata.astpid=this.objfilt.astpid;
        //this.saveevpattern(objdata);
      
    }
  
    
    openasses(content,objdata,cmd) {
      debugger
      if(cmd=='insert')
      {
        this.objco={};
       
        
        
        this.objco.coid='0';
        this.objco.cocd='';
        this.objco.conm='';
         this.objco.leid='0';
          this.objco.active='Yes';
        this.objco.suid=this.objfilt.suid;
        this.objco.clid=this.objfilt.clid;
        this.objco.crid=this.objfilt.crid;
        // this.objsubcat.subcacd='';
        //this.objsubcat.subcanm='';
        this.objco.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
        this.objco=objdata;
        this.objco.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
    

     openmethod(content,objdata,cmd) {
      debugger
      if(cmd=='insert')
      {
        this.objmethod={};
       
        
        
        this.objmethod.meid='0';
        this.objmethod.mecd='';
        this.objmethod.menm='';
         this.objmethod.active='Yes';
        // this.objastype.suid=this.objfilt.suid;
        // this.objsubcat.subcacd='';
        //this.objsubcat.subcanm='';
        this.objmethod.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
        this.objmethod=objdata;
        this.objmethod.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }
   
    delco(obj)
    {
      if(confirm("Are you sure you wan't to delete"))
      {
  
        this.objastype=obj;
        this.objastype.oprtype='delco';
        this.saveastype();
      }
    }
  
  saveastype()
  {
  console.log('saveobj',this.objco);
    this.mservice.save_obemco(this.objco)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
            //  this.masasstype();
            this.getobemco(this.objfilt);
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }



  save_obemtmethod()
  {
  console.log('saveobj',this.objmethod);
    this.mservice.save_obemtmethod(this.objmethod)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
            //  this.masasstype();
           this.getobemtmethod();
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }


    openpo(content,objdata,cmd) {
      debugger
      if(cmd=='insert')
      {
        this.objpo={};
       
        
        
        this.objpo.poid='0';
        this.objpo.pocd='';
        this.objpo.ponm='';
        this.objpo.podes='';
         this.objpo.active='Yes';
          this.objpo.crid=this.objfilt1.crid;
        // this.objastype.suid=this.objfilt.suid;
        // this.objsubcat.subcacd='';
        //this.objsubcat.subcanm='';
        this.objpo.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
        this.objpo=objdata;
        this.objpo.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'md'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }

     save_obempo()
  {
  console.log('saveobj',this.objpo);
    this.mservice.save_obempo(this.objpo)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
            //  this.masasstype();
           this.getobempo(this.objfilt1.crid);
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }


   openlevels(content,objdata,cmd) {
      debugger
      if(cmd=='insert')
      {
        this.objlevel={};
       
        
        
        this.objlevel.leid='0';
        this.objlevel.lecd='';
        this.objlevel.lenm='';
        this.objlevel.ledes='';
        this.objlevel.ledom='Cognitive';
         this.objlevel.active='Yes';
       
        this.objlevel.oprtype='insert';
       
      }
    
      else if(cmd=='update')
      {
        this.objlevel=objdata;
        this.objlevel.oprtype='update';
      }
      
      this.modalOptions = {
        backdrop:'static',
        backdropClass:'customBackdrop',
        size:'lg'
       
      }
      this.modalRef=this.modalService.open(content,this.modalOptions);
      
      this.modalRef.result.then((result) => {
     
           
        }, (reason) => {
            
        });
    }


    save_obemlevels()
  {
  console.log('saveobj',this.objlevel);
    this.mservice.save_obemlevels(this.objlevel)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if(result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
            //  this.masasstype();
           this.getobemlevels();
            }
           else
           {
  
           }
        },
        error =>{ alert('Error While saving...');}
        )
  }


   openpomap(content,objdata) {
      
         var coid=objdata.coid;
      
     this.getposmapped(coid);
      
       
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'lg'
        
       }
       this.modalRef=this.modalService.open(content,this.modalOptions);
       
       this.modalRef.result.then((result) => {
      
            
         }, (reason) => {
             
         });
     }
    

      getposmapped(coid) {
          var pst={coid:coid,crid:this.objfilt.crid};
       this.mservice.getposmapped(pst)
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.arrashead = resultArray;
              
           },
           error => console.log("Error :: " + error)
           )
     }


 printcertificate(){
  debugger
  var clcd=localStorage.getItem('clcd');
  var aycd=localStorage.getItem('aycd');

   var url=this.mservice.callurl+"/fpdf181/pdfreports/copomapping.php?clcd="+clcd+"&aycd="+aycd+"&clid="+this.objfilt.clid+"&crid="+this.objfilt.crid+"&suid="+this.objfilt.suid;

   window.open(url,'');
  
 }
     
    saveposmapped(obj,cmd)
  {
  // console.log('saveobj',this.objlevel);
  obj.oprtype=cmd;
    this.mservice.saveposmapped(obj)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            this.getposmapped(obj.coid);
            
        },
        error =>{ alert('Error While saving...');}
        )
  }


  getobemlpgeneral() {
          // var pst={coid:coid,crid:this.objfilt.crid};
       this.mservice.getobemlpgeneral(this.objgenfilt)
           .subscribe(
           resultArray => {
               console.log('getdashcounts', resultArray);
               this.arrgenmas = resultArray;
              
           },
           error => console.log("Error :: " + error)
           )
     }

deletegenmas(obj)
{
  if(confirm("Are you sure you wan't to delete"))
  {
    this.objgen=obj;
    this.objgen.oprtype='delete';
    this.save_obemlpgeneral();
  }
}

      save_obemlpgeneral()
  {
  // console.log('saveobj',this.objlevel);
  // obj.oprtype=cmd;
    this.mservice.save_obemlpgeneral(this.objgen,this.objgenfilt)
        .subscribe(
        result => {
            console.log('SavegenmasDetails', result);
            //this.suppliers = resultArray;
            alert(result.message);
            if (result.status=='success')
            {
              let localmodref=this.modalRef;
              localmodref.close();
              this.getobemlpgeneral();
            }
            
            
            
        },
        error =>{ alert('Error While saving...');}
        )
  }

  
   opengenmas(content,objdata,cmd) {
      
        if(cmd=='insert')
      {
        this.objgen={};
        this.objgen.gnm='';
        this.objgen.rid='0';
        this.objgen.gtype='Reference Books';
       
        this.objgen.oprtype='insert';
      }
      else if(cmd=='update')
      {
        this.objgen=objdata;
        this.objgen.oprtype='update';
      }
      
       
       this.modalOptions = {
         backdrop:'static',
         backdropClass:'customBackdrop',
         size:'md'
        
       }
       this.modalRef=this.modalService.open(content,this.modalOptions);
       
       this.modalRef.result.then((result) => {
      
            
         }, (reason) => {
             
         });
     }
    
 
  }
  
